export const DATE = 'D. MMMM YYYY';
export const DATE_MARK = 'DD.MM.YYYY';
export const DATE_SEND = 'YYYY-MM-DD';
export const DATE_SEND_WITH_TIME = 'YYYY-MM-DD HH:mm:ss';
export const TIME_SEND = 'HH:mm';
export const DATE_WITH_TIME = 'D MMM YYYY, HH:mm';
export const GENERAL_NUMBER = '0,0.[00]';
